import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
// RxJS
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
// Object-Path
import * as objectPath from 'object-path';
// Layout
import {
  LayoutConfigService,
  MenuConfigService,
  MenuHorizontalService,
  MenuOptions,
  OffcanvasOptions,
} from '../../../../core/_base/layout';
// HTML Class
import { HtmlClassService } from '../../html-class.service';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { currentUser, isLoggedIn } from '../../../../core/auth';
import { Observable } from 'rxjs';
import { User } from '@app/model/user';
import { FormControl, FormGroup } from '@angular/forms';

import { SystemSettingService } from '@app/api/systemsettting.service';
import { environment } from 'environments/environment';
import { SystemSettingStore } from '@app/services/change-setting.service';
@Component({
  selector: 'kt-menu-horizontal',
  templateUrl: './menu-horizontal.component.html',
  styleUrls: ['./menu-horizontal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuHorizontalComponent implements OnInit, AfterViewInit, OnDestroy {
  // Public properties
  hideMenu: boolean = false;
  currentRouteUrl: any = '';
  urlLogo: string = '';
  logoLoaded: boolean = false;
  rootArrowEnabled: boolean;

  menuOptions: MenuOptions = {
    submenu: {
      desktop: 'dropdown',
      tablet: 'accordion',
      mobile: 'accordion',
    },
    accordion: {
      slideSpeed: 200,
      expandAll: false,
    },
    dropdown: {
      timeout: 50,
    },
  };

  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'kt-header-menu-wrapper',
    closeBy: 'kt_header_menu_mobile_close_btn',
    toggleBy: {
      target: 'kt_header_mobile_toggler',
      state: 'kt-header-mobile__toolbar-toggler--active',
    },
  };

  search: any = '';
  user$: Observable<User>;
  isLogin: boolean = false;

  private destroy$ = new Subject<void>(); // Để unsubscribe

  constructor(
    private el: ElementRef,
    public htmlClassService: HtmlClassService,
    public menuHorService: MenuHorizontalService,
    private menuConfigService: MenuConfigService,
    private layoutConfigService: LayoutConfigService,
    private router: Router,
    private render: Renderer2,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private system: SystemSettingService,
    private storeSystem: SystemSettingStore
  ) {
    this.currentUrl = this.router.url;

    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

        if (!this.currentUrl.includes('searchresultpage')) {
          this.search = '';
          this.searchForm.patchValue({ search: '' });
        }
      }
    });
  }

  currentUrl: string = '';
  previousUrl: string = '';
  searchForm = new FormGroup({
    search: new FormControl(''),
  });

  ngAfterViewInit(): void {}

  ngOnInit(): void {
    this.rootArrowEnabled = this.layoutConfigService.getConfig('header.menu.self.root-arrow');

    this.currentRouteUrl = this.router.url;
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        this.currentRouteUrl = this.router.url;
        this.cdr.markForCheck();
      });

    // isLoggedIn — có giá trị ngay khi Login action dispatch
    this.store.pipe(select(isLoggedIn)).pipe(takeUntil(this.destroy$)).subscribe(loggedIn => {
      if (loggedIn) {
        this.isLogin = true;
      } else {
        const token = localStorage.getItem(environment.authTokenKey);
        this.isLogin = !!(token && token.length > 10);
      }
      this.cdr.detectChanges();
    });

    this.user$ = this.store.pipe(select(currentUser));
    this.user$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.isLogin = true;
      }
      this.cdr.detectChanges();
    });

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      if (params['search'] && this.router.url.includes('searchresultpage')) {
        this.search = params['search'];
        this.searchForm.patchValue({ search: this.search });
        this.cdr.markForCheck();
      }
    });

    this.getLogo();
    this.subscribeToLogoUpdates();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getLogo() {
    this.system
      .apiSystemSettingGet('type==HEADER-ICONS')
      // .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.success && res.data.collection && res.data.collection.length > 0) {
            const children = res.data.collection[0].children;
            if (children && children.length > 0) {
              const logo = children.find(
                (item) => item.value && item.value !== '' && item.is_hidden === false
              );

              if (logo && logo.value) {
                this.urlLogo = environment.backendhost + logo.value + '?cb=' + Date.now();
                this.logoLoaded = true;
                console.log('Logo loaded from API:', this.urlLogo);
                this.cdr.markForCheck();
              }
            }
          }
        },
        error: (err) => {
          console.error('Error loading logo:', err);
        },
      });
  }

  subscribeToLogoUpdates() {
    this.storeSystem.settings$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (settings) => {
        if (settings && settings.logos && settings.logos.length > 0) {
          const activeLogo = settings.logos.find(
            (item) => item.value && item.value !== '' && item.is_hidden === false
          );

          if (activeLogo && activeLogo.value) {
            const baseUrl = activeLogo.value.startsWith('http')
              ? activeLogo.value
              : environment.backendhost + activeLogo.value;
            this.urlLogo = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'cb=' + Date.now();
            this.logoLoaded = true;

            console.log('Logo updated from settings:', this.urlLogo);

            this.cdr.markForCheck();
          }
        }
      },
      error: (err) => {
        console.error('Error subscribing to settings:', err);
      },
    });
  }

  getItemCssClasses(item) {
    let classes = 'kt-menu__item';
    if (!item.submenu && this.isMenuItemIsActive(item)) {
      classes += ' kt-menu__item_menu--active ';
    }
    return classes;
  }

  getItemAttrSubmenuToggle(item) {
    let toggle = 'hover';
    if (objectPath.get(item, 'toggle') === 'click') {
      toggle = 'click';
    } else if (objectPath.get(item, 'submenu.type') === 'tabs') {
      toggle = 'tabs';
    }
    return toggle;
  }

  getItemMenuSubmenuClass(item) {
    let classes = '';
    const alignment = objectPath.get(item, 'alignment') || 'right';
    if (alignment) {
      classes += ' kt-menu__submenu--' + alignment;
    }
    const type = objectPath.get(item, 'type') || 'classic';
    if (type === 'classic') {
      classes += ' kt-menu__submenu--classic';
    }
    if (type === 'tabs') {
      classes += ' kt-menu__submenu--tabs';
    }
    if (type === 'mega') {
      if (objectPath.get(item, 'width')) {
        classes += ' kt-menu__submenu--fixed';
      }
    }
    if (objectPath.get(item, 'pull')) {
      classes += ' kt-menu__submenu--pull';
    }
    return classes;
  }

  isMenuItemIsActive(item): boolean {
    if (item.submenu) {
      return this.isMenuRootItemIsActive(item);
    }
    if (!item.page) {
      return false;
    }
    return this.currentRouteUrl.indexOf(item.page) !== -1;
  }

  isMenuRootItemIsActive(item): boolean {
    if (item.submenu.items) {
      for (const subItem of item.submenu.items) {
        if (this.isMenuItemIsActive(subItem)) {
          return true;
        }
      }
    }
    if (item.submenu.columns) {
      for (const subItem of item.submenu.columns) {
        if (this.isMenuItemIsActive(subItem)) {
          return true;
        }
      }
    }
    if (typeof item.submenu[Symbol.iterator] === 'function') {
      for (const subItem of item.submenu) {
        const active = this.isMenuItemIsActive(subItem);
        if (active) {
          return true;
        }
      }
    }
    return false;
  }

  hideMenuHorizontal() {
    this.hideMenu = true;
  }

  nextPageSearch() {
    this.router.navigate(['/searchresultpage'], { queryParams: { search: this.search.trim() } });
  }

  clickLogo() {
    const homeUrl = '/homepage';
    if (this.router.url.includes(homeUrl)) {
      window.scrollTo(0, 0);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([homeUrl]);
      });
    } else {
      this.router.navigate([homeUrl]).then(() => {
        window.scrollTo(0, 0);
      });
    }
  }
}
